import * as React from 'react';
import { forwardRef } from 'react';
import { AppBar, Layout, UserMenu, useLogout } from 'react-admin';
import { ProjectsDashboardMenu } from './Menu'
import { MenuItem } from '@mui/material';
import ExitIcon from '@mui/icons-material/PowerSettingsNew';
import { useNavigate } from 'react-router-dom'; 



const MyAppBar = () => <AppBar userMenu={<UserMenu />} />;

export const ProjectsDashboardLayout = (props) => (
    <Layout {...props} menu={ProjectsDashboardMenu} appBar={MyAppBar} />
);
